module.exports = __webpack_public_path__ + "static/media/bug.fc502b1d.jpg";